module.exports = __webpack_public_path__ + "static/img/eightBox.f8018c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eightBox.png
// module id = Mg8W
// module chunks = 1